module.exports = __webpack_public_path__ + "img/informasi-rdp.fb3d0308.svg";